export default __webpack_public_path__ + "static/gearsEsports-d350311bd9938c02a2ffb07cdbae55d6.svg";